import { DASHBOARD_TODO_LIST_MAIN_EXPANDED_KEY, persistentStorage } from '#shared/lib/storage';

export function readDashboardTodoListMainExpanded(): boolean {
    if (typeof window === 'undefined') {
        return true;
    }

    const stored = persistentStorage.getItem(DASHBOARD_TODO_LIST_MAIN_EXPANDED_KEY);

    if (stored === '0') {
        return false;
    }

    return true;
}

export function writeDashboardTodoListMainExpanded(expanded: boolean): void {
    persistentStorage.setItem(DASHBOARD_TODO_LIST_MAIN_EXPANDED_KEY, expanded ? '1' : '0');
}
